<template>
    <v-row no-gutters>
        <v-col cols="12">
            <h2>Filter</h2>
        </v-col>
        <v-col>
            <QAutoComplete :label="$t('servicesystem.common_objects.contract.contract_type')" v-model="filter.ContractTypeIds" :list="contractTypes" textkey="Name"
                valuekey="Id" multiple clearable externaledit :placeholder="'Select contract types...'"></QAutoComplete>
        </v-col>    
        <v-col cols="auto" class="my-auto ml-2">
            <QButtonGroup noempty v-model="filter.ContractStatus" :list="contractStatusModes" label="Contract Status:"
                multiple class="mr-2"></QButtonGroup>
        </v-col>
        <v-col cols="12">
            <v-row no-gutters>
                <v-col>
                    <QDateField class="mr-2" :label="$t('servicesystem.common_objects.contract.created_before')" v-model="filter.ContractStartBefore" :min="null" :max="null"
                        externaledit>
                    </QDateField>
                </v-col>
                <v-col cols="auto" class="my-auto">
                    <QButtonGroup noempty v-model="filter.ContractDetailStatus" :list="contractDetailStatusModes"
                        label="Contract Detail Status:" multiple class="mr-2"></QButtonGroup>
                    <QButtonGroup noempty v-model="filter.ContractDetailPriceMode" :list="contractDetailPriceModels"
                        label="Contract Detail Price Type:" multiple class="mr-2">
                    </QButtonGroup>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>
<script>
import ClientAPIMixin from '@/api/ClientAPIMixin';
import QAutoComplete from '@/components/Inputs/QAutoComplete.vue';
import QButtonGroup from '@/components/Inputs/QButtonGroup.vue';
import QDateField from '@/components/Inputs/QDateField3.vue';

export default {
    name: 'ContractDetailPriceChangeFilterControl',
    components: {
        QDateField,
        QButtonGroup,
        QAutoComplete,
    },
    props: {
        filter: {
            type: Object,
            required: true
        },
    },
    mixins: [ClientAPIMixin],
    mounted() {
        this.getContractTypeListFromFilter().then(contractTypes => {
            this.contractTypes = contractTypes.filter(ct => ct.Type == 0);
        });
    },
    data() {
        return {
            contractTypes: [],
            contractStatusModes: [
                { text: this.$t('servicesystem.common_objects.contract.active'), value: 1 },
                { text: this.$t('servicesystem.common_objects.contract.inactive'), value: 2 }
            ],
            contractDetailStatusModes: [
                { text: this.$t('servicesystem.common_objects.contract.active_lines'), value: 1 },
                { text: this.$t('servicesystem.common_objects.contract.terminated'), value: 2 }
            ],
            contractDetailPriceModels: [
                { text: this.$t('servicesystem.common_objects.contract.per_month'), value: 1 },
                { text: this.$t('servicesystem.common_objects.contract.per_unit'), value: 2 }
            ],
        };
    },
}
</script>
